import React, {FC} from 'react';
import cn from 'classnames';
import Image from 'next/image';

import styles from './styles.module.scss';

export type DefaultStepLayoutHideIcon = Array<'mobile' | 'desktop'>;
export interface DefaultStepLayoutProps {
  icon: {
    src?: string;
    width?: number;
    height?: number;
    hidden?: DefaultStepLayoutHideIcon;
    fontAwesomeIcon?: string;
  };
  title: string;
  description?: string;
  children: React.ReactElement;
}

const DefaultStepLayout: FC<DefaultStepLayoutProps> = ({
  icon,
  title,
  description,
  children,
}) => {
  const imageClassName = cn(styles.stepLayout__icon, {
    [styles.stepLayout__icon__modHiddenMobile]: icon.hidden?.includes('mobile'),
    [styles.stepLayout__icon__modHiddenDesktop]:
      icon.hidden?.includes('desktop'),
  });

  const lowercaseTitle = title
    .toLowerCase()
    .replace(/ /g, '_')
    .replace(/[.!]/g, '');
  const stepTitleId = `step_title_${lowercaseTitle}`;
  const iconContainerId = `step_icon_container_${lowercaseTitle}`;

  return (
    <div className={styles.stepLayout}>
      <div id={iconContainerId} className={imageClassName}>
        {icon?.fontAwesomeIcon ? (
          <i className={cn(styles.stepLayout__icon, icon.fontAwesomeIcon)} />
        ) : (
          <Image
            src={icon.src}
            alt="step icon"
            width={icon.width}
            height={icon.height}
          />
        )}
      </div>
      <h2 id={stepTitleId} className={styles.stepLayout__title}>
        {title}
      </h2>
      {description && (
        <p className={styles.stepLayout__description}>{description}</p>
      )}
      <div className={styles.stepLayout__children}>{children}</div>
    </div>
  );
};

export default DefaultStepLayout;
